const AD_DOMAINS = ['https://americandream.com', 'https://americandream.dev'];
const REVENUE_KEYWORDS = ['book', 'buy', 'purchase', 'pay'];

const REVENUE_OBJECTS = [
  'pass',
  'ticket',
  'stay',
  'membership',
  'subscription',
  'plan',
  'reservation',
];

export const STANDARD_EVENTS = {
  click: 'click',
  revenueClick: 'cta_click',
  addWallet: 'add_to_wallet',
  formSubmit: 'form_submit',
  signUp: 'sign_up',
  carouselSlide: 'carousel_slide',
  search: 'search',
  searchClick: 'search_result_click',
  filter: 'filter',
  outboundClick: 'outbound_click',
  selectPromotion: 'select_promotion',
};

export const CTA_TYPES = {
  link: 'link',
  button: 'button',
  jump: 'jump',
  pagination: 'pagination',
  filter: 'filter',
  download: 'download',
  modal: 'modal',
  showMore: 'show-more',
  tab: 'tab',
};

export const PAGE_TYPES = {
  landing: 'landing',
  attraction: 'attraction',
};

export const FORM_TYPES = {
  subscribe: 'subscribe',
};

export const MIN_SEARCH_LENGTH = 4;

const isRevenueLabel = (label) => {
  const hasRevenueKeyword = REVENUE_KEYWORDS.some((word) =>
    label.includes(word)
  );
  if (hasRevenueKeyword) return true;

  const hasRevenueObject = REVENUE_OBJECTS.some((word) => label.includes(word));

  if ((label.startsWith('get') || label.startsWith('make')) && hasRevenueObject)
    return true;

  return false;
};

const isRevenuePath = (path) => {
  if (!path) return false;
  if (path.endsWith('/tickets')) return true;
  if (/^\/bundle\/[^/]+/.test(path)) return true;
  return false;
};

const getEventName = ({ event, params }) => {
  if (
    event === STANDARD_EVENTS.click &&
    params.destination_url &&
    params.destination_url.includes('http') &&
    !AD_DOMAINS.some((domain) => params.destination_url.includes(domain))
  )
    return STANDARD_EVENTS.outboundClick;

  if (!params.label) return event;
  if (
    isRevenueLabel(params.label.toLowerCase()) ||
    isRevenuePath(params.destination_url)
  ) {
    return STANDARD_EVENTS.revenueClick;
  }
  return event;
};

const isPromoClick = ({ event, params }) =>
  event === STANDARD_EVENTS.click &&
  params?.label?.toLowerCase()?.includes('discount');

export const ga4Track = ({ event, params }) => {
  try {
    window.dataLayer.push({
      event: getEventName({ event, params }),
      ...params,
    });
    if (isPromoClick({ event, params })) {
      window.dataLayer.push({
        event: STANDARD_EVENTS.selectPromotion,
        ...params,
      });
    }
  } catch (e) {
    console.error(`Error while tracking to GA4, ${e}`);
  }
};
